<template>
  <div class="content-main">

    <van-popup v-model="loading" class="pop-loading">
      <div class="loading">
        <span>正在拼命加载中，请稍等片刻～</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

    <van-popup v-model="show_notice" class="pop-notice" :close-on-click-overlay="false">
      <div class="notice">
        <div class="title">留言须知</div>
        <div class="notice-item  flex-box">
          <!-- <div>1.</div><div>为维护社区环境，每条留言都会进行审核，会产生较大的人工成本，因此我们决定象征性地进行收费，收费标准为1/条，用于支付审核费用，感谢理解与支持。</div> -->
          <span>1.&nbsp;&nbsp;</span><span>系统会记录用户实名信息，请自觉维护社区环境。</span>
        </div>
        <div class="notice-item flex-box">
          <span>2.&nbsp;&nbsp;</span><span>留言内容须保持友善和尊重，不得违背社会公德及法律法规，用户须对自己发表的内容负责，平台有权删除不符合社区规范的留言。</span>
        </div>
        <div class="notice-item flex-box">
          <span>3.&nbsp;&nbsp;</span><span>发表留言前，请先阅读<span class="community-rule" @click="goCommunityRules()">《社区规范》</span></span>
        </div>
        <div class="notice-item flex-box choose">
          <van-checkbox v-model="readNoticeChecked"></van-checkbox>
          <span>已阅读并同意上述须知及《社区规范》</span>
        </div>
        <div class="notice-item flex-box choose">
          <van-checkbox v-model="unNoticeChecked"></van-checkbox>
          <span>下次不再提示</span>
        </div>
        <div class="btn-confirm" @click="confirmNotice()">确认</div>
      </div>
    </van-popup>

    <div class="shanzha" v-if="!submit_result && !show_friend_notify">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div>

      <div class="message">

        <div class="info-input flex-box username">
          <div class="input-label">好友名字</div>
          <input class="username-content" placeholder="请填写好友名字或暗号" v-model="username" />
        </div>

        <div class="info-input flex-box message-content">
          <div class="input-label">留言内容</div>
          <textarea class="message-text" rows="4" maxlength="140" placeholder="请填写留言内容" v-model="info"></textarea>
        </div>

        <div class="anony-and-count flex-box">
          <van-checkbox v-model="anonymous" label-position="left">不显示头像/昵称</van-checkbox>
          <span>字数：{{info.length}}/ 140</span>
        </div>

        <div class="btn-submit" @click="handlePay()">提交留言</div>
        <!-- <div class="btn-submit" @click="handlePay()">付款</div> -->

      </div>

      <div class="rules-hint" @click="goCommunityRules()">
        👉🏻&nbsp;&nbsp;留言须遵守<span class="filename">《社区管理规范》</span>
      </div>

    </div>

    <div class="page-success" v-if="submit_result">
      <img class="img-success" src="https://static.huiyiji520.com/submit-success-210916.png">
      <div class="hint hint1">留言提交成功！等待内容审核</div>
      <div class="hint hint2">预计{{getAuditTimeCost()}}小时内完成审核</div>
      <div class="hint hint2">审核时间为早9:00～晚18:00</div>
      <div class="hint hint2">审核通过以后，留言内容自动公开</div>
      <div class="btn-back" @click="goIndex()">返回首页</div>
    </div>

    <div class="page-success" v-if="show_friend_notify">
      <!-- <img class="img-success" src="https://static.huiyiji520.com/submit-success-210916.png"> -->
      <div class="hint hint1">留言提交成功！</div>
      <div class="hint hint2">快去提醒好友来查看你的留言！</div>
      <div class="hint hint3">↓↓&nbsp;&nbsp;提醒示例&nbsp;&nbsp;↓↓</div>
      <img class="notify-example" src="https://static.langmanyuan.com/2063888526.jpg">
      <div class="btn-back" @click="goIndex()">返回首页</div>
    </div>

    <!-- <div class="btn-check flex-box" @click="goMessageCheck"><div class="btn-txt flex-box"><div>查看</div><div>留言</div></div></div> -->


    <van-tabbar v-model="tabActive" active-color="#b17e94">
      <van-tabbar-item icon="wap-home" @click="goHome()">首页</van-tabbar-item>
      <van-tabbar-item icon="eye-o" @click="goMessageCheck()">看留言</van-tabbar-item>
      <van-tabbar-item icon="envelop-o">写留言</van-tabbar-item>
      <van-tabbar-item icon="manager-o" @click="goUserCenter()">个人中心</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Dialog } from 'vant'

export default{
  data(){
    return {
      username: '',
      info: '',
      anonymous: false,
      submit_result: false,
      paid: false,
      loading: false,
      show_notice: this.$store.state.userinfo.notice,
      readNoticeChecked: false,
      unNoticeChecked: false,
      tabActive: 2,
      show_friend_notify: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goHome(){
      this.$router.replace("/")
    },
    goIndex(){
      this.$router.replace('/message_choose')
    },
    goUserCenter(){
      this.handleRouter('/user_center')
    },
    goMessageCheck(){
      this.$router.replace("/message_check")
    },
    goCommunityRules(){
      this.handleRouter('/community_rules')
    },
    handlePay(){
      if(this.username.trim().length == 0){
        Toast('请输入好友名字或暗号')
      }else if(this.username.trim().length > 8){
        Toast('好友名字或暗号不能超过8个字')
      }else if(this.info.trim().length == 0){
        Toast('请输入留言内容')
      }else if(this.loading){
        return
      }else{
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        // alert("openid: " + this.$store.state.userinfo.openid)
        this.$api.post('/garden/submit_msg_for_free_compatible', {openid: openid, watchword: this.username.trim(), msg: this.info.trim(), anonymous: this.anonymous, address: this.$store.state.siteCode}, res => {
          if(res.code == 200){
            // alert("pay res: " + JSON.stringify(res))
            this.loading = false
            let _this = this
            this.paid = true
            if(res.status == "pending"){
              this.submit_result = true
            }else{
              // Toast("留言提交成功！")
              // this.$router.replace("/message_check?receiver=" + this.username.trim())
              this.show_friend_notify = true
            }
          }else if(res.code == 413){
            this.loading = false
            this.username == ""
            Toast(res.msg)
          }else{
            this.loading = false
            Toast(res.msg)
            // this.goMessageCheck()
          }
        })
      }
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });

        }
      })
    },
    getAuditTimeCost(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 18){
        return "12"
      }else{
        return "24"
      }
    },
    checkTimeForCreate(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 24){
        return true
      }else{
        return false
      }
    },
    checkTimeDialog(){
      if(!this.checkTimeForCreate()){
        Dialog.alert({
          title: '提示',
          message: '写留言时间为：早9点～晚24点\n其余时间仅可查看留言'
        }).then(() => {
          this.goMessageCheck()
        });
      }
    },
    checkUserSilent(){
      if(this.$store.state.userinfo.silent == 1){
        Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
        this.goMessageCheck()
      }
    },
    confirmNotice(){
      if(!this.readNoticeChecked){
        Toast('未勾选「已阅读并同意」')
      }else if(this.unNoticeChecked){
        this.$store.commit('updateUserNotice', {
          notice: false
        })
        this.show_notice = false

        let openid = this.$store.state.userinfo.openid
        this.$api.post('/garden/no_more_rule_notice', {openid: openid}, res => {})
      }else{
        this.show_notice = false
      }
    }
  },
  mounted(){
    this.checkUserSilent()
    // this.checkTimeDialog()
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#b17e94;}
.shanzha{padding:15px;padding-top:25px;}
.logo-and-wish{font-size:17px;margin-bottom:20px;}
.logo{height:100px;width:100px;border-radius:100px;margin-right:25px;}
.message {background:#fff;padding:25px;}
.message .info-input{padding-bottom:15px;}
.message .username{border-bottom:1px solid #b17e94;}
.message .input-label{font-size:14px;margin-right:20px;}
.username .username-content{font-size:13px;flex-grow:1;border:none;color:#333;}
.message .message-content{padding-top:15px;align-items:flex-start;}
.message-content .message-text{font-size:13px;flex-grow:1;border:none;color:#333;line-height:2.0;}
.anony-and-count{font-size:12px;justify-content:space-between;color:#969799;}
.btn-submit{background:#b17e94;color:#fff;font-size:15px;font-weight:340;height:45px;line-height:45px;margin-top:20px;}
.btn-check{
  width:80px;height:80px;border-radius:80px;background:#b17e94;position:fixed;
  bottom:70px;right:15px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;border:1px solid #fff;width:66px;height:66px;
  border-radius:66px;border:1px solid #fff;font-size:15px;
}
*::-webkit-input-placeholder {color: #969799;font-size:12px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:12px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:12px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:12px;}
.page-success{padding-top:100px;}
.img-success{width:80px;height:80px;margin-bottom:30px;visibility:visible;}
.page-success .hint{margin-bottom:15px;font-size:17px;}
.page-success .hint1{color:#333;}
.page-success .hint2{color:#333;}
.page-success .hint3{color:#dd4b39;}
.notify-example{width:90%;}
@media (max-height: 500px) {
  .btn-check {
    display: none;
  }
}
.van-popup{width:70%;padding:20px;}
.pop-loading{
  background:rgba(255,255,255,0);
  color:#fff;
}
.content-main .loading .van-loading{
  margin:0 auto;
  margin-bottom:15px;
  margin-top:30px;
}
.content-main .loading{
  font-size:13px;
  padding:20;
}
.btn-back{
  background:#4caf50;color:#fff;font-size:15px;height:45px;line-height:45px;
  margin:0 auto;margin-top:30px;width:70%;border-radius:2px;
}
.rules-hint{font-size:12px;margin-top:20px;text-align:left;}
.rules-hint .filename{border-bottom:1px solid #b17e94;padding-bottom:2px;}
.pop-notice{border-radius:10px;color:#333;top:45%;}
.pop-notice .title{font-size:18px;font-weight:bold;margin-bottom:20px;}
.pop-notice .notice-item{
  align-items:flex-start;justify-content:flex-start;text-align:left;margin-bottom:15px;
  font-size:14px;line-height:18px;
}
.pop-notice .notice-item .community-rule{border-bottom:1px solid #0769cb;color:#0769cb;}
.pop-notice .notice .choose{font-size:12px;color:#666;align-items:center;}
.pop-notice .van-checkbox{margin-right:10px;}
.pop-notice .btn-confirm{background:#b17e94;color:#fff;font-size:14px;width:50%;padding:10px;border-radius:5px;margin:0 auto;}
</style>
